/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import PopupUtils from '@utils/popup-utils'
import { FROM_VIEW_TYPE } from '@v2/constants/common'
import StorageUtils from '@utils/storage-utils'
import { PAGE_TYPE } from '@interface/common'
import DialogUtils from '@utils/dialog-utils'
import styled from '@themes/theme'
import { PopupImgCommonStyle } from '@styles/base.style'
import { Button } from '@styles/button.style'
// img
import UserPickGiveawayImg from '@assets/images/banner/user-pick-product/user_pick_giveaway.jpg'

const GiveawayInfoWrap = styled.div`
  width: 100%;
  height: inherit;
  overflow: auto;

  img {
    width: 100%;
    height: auto;
  }
`
const UserPickBottomBtnStyle = css`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 66px;
  border-radius: 0;
  background: linear-gradient(130deg, #29D3E6, #01BACE) !important;
  box-shadow: inset 0 1px 1px #56D9E850;
  font-size: 24px;
  text-shadow: 0 1px 3px #016D7E20;
`

export const UserPickGiveawayInfo: React.FC = observer(() => {
  const { bettingHistoryStore, globalStore } = useRootStore()
  const { onGoingBetCount } = bettingHistoryStore

  const onClickOpenEditor = () => {
    if (bettingHistoryStore.selectedBettingHistoryFoldData) {
      PopupUtils.showUserPickEditor(FROM_VIEW_TYPE.BETTING_HISTORY)
    }
  }

  const showBettingHistory = () => {
    StorageUtils.saveShowUserPickFirstInfo()
    PopupUtils.showBettingHistory({ onClick: onClickOpenEditor, pageType: PAGE_TYPE.USER_PICK })
  }

  const onClickUserPickWriter = () => {
    globalStore.closeGeneralPopup()
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.USER_PICK)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: true, fromViewType: FROM_VIEW_TYPE.USER_PICK })
    const item = StorageUtils.isShowUserPickFirstInfo()
    if (item) {
      showBettingHistory()
    } else {
      if( onGoingBetCount === 0 ){
        StorageUtils.saveShowUserPickFirstInfo()
        DialogUtils.showUserPickNullOngoingBetInfo()
      } else {
        DialogUtils.showUserPickIsOngoingBetInfo({ closeCallback: showBettingHistory })
      }
    }
  }

  return (
    <GiveawayInfoWrap>
      <img src={UserPickGiveawayImg} alt="작성혜택 안내 이미지" css={PopupImgCommonStyle} loading="lazy"/>
      <Button primary css={UserPickBottomBtnStyle} onClick={onClickUserPickWriter}>작성하고 혜택받기</Button>
    </GiveawayInfoWrap>
  )
})
